import React from 'react';
import {GtmPageTypes} from '~/src/utilities/constants/tracking';

interface PageState {
    canonicalUrl?: string;
    gtmPageType: string;
}

const PageContext = React.createContext<PageState>({
    gtmPageType: GtmPageTypes.OTHER
});

export default PageContext;
